import React, { memo } from 'react';

import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { Tabs } from '@bringg/react-components';

import { TypographyH3 } from '../typography/typography';

import styles from './product-page-layout.module.scss';

export type ProductPageTab = {
	key: string;
	label: string;
};

export interface ProductPageLayoutProps {
	title: string;
	testId: string;
	activeKey: string;
	tabs: ProductPageTab[];
	children: React.ReactNode;
	floatingAction?: React.ReactNode;
	className?: string;
}

export const ProductPageLayout: React.FC<ProductPageLayoutProps> = memo(
	({ title, testId, activeKey, tabs, children, floatingAction, className }) => {
		const history = useHistory();

		return (
			<div className={classNames(styles.productPageLayout, className)}>
				<header className={styles.header} data-test-id={`${testId}-header`}>
					<TypographyH3 className={styles.title} tag="h1">
						{title}
					</TypographyH3>
					<Tabs
						animated={false}
						className={styles.tabs}
						activeKey={activeKey}
						items={tabs}
						onChange={path => history.push(path)}
						data-test-id={`${testId}-tabs`}
					/>
				</header>

				<div className={styles.content}>{children}</div>

				{floatingAction}
			</div>
		);
	}
);

ProductPageLayout.displayName = 'ProductPageLayout';
